import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { getAuthUser } from '../../../helpers'
import { Loading, TooltipWrapper } from '../../common'
import { Record } from '../../../models'
import { getRecord } from '../../../api'
import { EditRecordRefundForm } from './edit'
import { RecordTable } from './resourceTable'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../../common'

export const RecordRefundCard = () => {
    const [record, setRecord] = useState<Record>()
    const [isEditing, setIsEditing] = useState(false)
    const params = useParams()
    const ability = defineAbilityFor(getAuthUser())

    useEffect(() => {
        if (params.recordId && ability.can('View', 'RefundRecord')) {
            getRecord(params.recordId).then((response) => {
                if (response.status === 200) {
                    setRecord(new Record(response.data))
                }
            })
        }
    }, [params.recordId])

    if (!ability.can('View', 'RefundRecord')) {
        return <InsufficientPermissions />
    }

    if (!(record instanceof Record)) {
        return <Loading />
    }

    return (
        <div className="container card col-xs-12 col-xl-6">
            <div className="card-body col-xs-12 row d-flex flex-row justify-content-between mb-5">
                <div className="row flex-row mb-5">
                    <h3 className="ps-0 d-inline-flex card-title w-50">{record.id}</h3>
                    <div className="pe-0 d-inline-flex justify-content-end w-50">
                        <TooltipWrapper
                            condition={!ability.can('Edit', 'RefundRecord')}
                            element={
                                <button
                                    className="btn btn-primary"
                                    disabled={!ability.can('Edit', 'RefundRecord')}
                                    onClick={() => setIsEditing(!isEditing)}
                                >
                                    Toggle Edit
                                </button>
                            }
                            message="Executive permission required to edit record"
                        />
                    </div>
                </div>
                {!isEditing && <RecordTable record={record} />}
                {isEditing && (
                    <EditRecordRefundForm
                        record={record}
                        setIsEditing={setIsEditing}
                        setRecord={setRecord}
                    />
                )}
            </div>
        </div>
    )
}
